import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  textTransform: 'none',
  fontWeight: 600,
  transition: theme.transitions.create(
    ['background-color', 'box-shadow', 'border-color', 'color'],
    {
      duration: theme.transitions.duration.short,
    }
  ),
  
  '&.MuiButton-contained': {
    boxShadow: 'none',
    
    '&:hover': {
      boxShadow: `0 4px 8px ${theme.palette.primary.main}33`,
    },
    
    '&:active': {
      boxShadow: `0 2px 4px ${theme.palette.primary.main}44`,
    },
  },
  
  '&.MuiButton-outlined': {
    borderWidth: 2,
    
    '&:hover': {
      borderWidth: 2,
      backgroundColor: `${theme.palette.primary.main}0a`,
    },
  },
  
  '&.MuiButton-text': {
    '&:hover': {
      backgroundColor: `${theme.palette.primary.main}0a`,
    },
  },
  
  '&:disabled': {
    opacity: 0.6,
  },
})); 